<template>
  <v-card tile>
    <v-card-title>
      <v-img
        max-height=250
        contain
        src="../assets/planner.png"
      />
    </v-card-title>
    <v-card-text>
      <p>
        This is a demo of a micro-service implemented using a <strong>serverless AWS Lambda function</strong>. In this demo we invoke the Lamda function
        via a <strong>REST API</strong> using the <strong>AWS API Gateway</strong>. We protect who can invoke the REST API by configuring
        an <strong>Authorizer</strong> in the API Gateway which uses <strong>AWS Cognito</strong>.
      </p>
      <p>
        Before we can invoke the REST API we need to get an access token. We have configured the <strong>POST /plan</strong> method
        in the API gateway to use an authorizer which issues a token with a <strong>planning/execute</strong> scope granted.
        The authorizer <strong>AbovoDayCarePlanningAuthorizer</strong> is configured to use <strong>Cognito</strong>. The authorizer is also configured
        to expect a header <strong>Authorization</strong> in the <strong>POST /plan</strong> containing a <strong>JSON WEB TOKEN</strong>.
      </p>
      <p>
        Amazon <strong>Cognito</strong> lets you add user sign-up, sign-in, and access control to your web and mobile apps. Amazon <strong>Cognito</strong>
        is the service which will issue us with a <strong>JSON WEB TOKEN</strong> to invoke the <strong>POST /plan</strong> method.
        The token must have <strong>planning/execute</strong> scope granted. In <strong>Cognito</strong> we have defined a <strong>User Pool</strong> and in
        this user pool we have configured a <strong>Client Application</strong> with scope <strong>planning/execute</strong>. So this tokens requested
        by this client have scope <strong>planning/execute</strong> granted and can invoke REST API using the
        authorizer <strong>AbovoDayCarePlanningAuthorizer</strong>
      </p>
      <p>
        To invoke the micro-service implemented in the Lambda function using the POST /plan REST API an invoker must first get an access token which
        needs to be passed as a header in the POST /plan API.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
